import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <>
        <footer>
          <div className="" style={{ background: "#737070" }}>
            <div className="container">
              <div className="ft-widget-area footer_main_div">
                <div className="row">
                  <div class="col-md-3 col-sm-6">
                    <div className="ft-area1">
                      <div className="swin-widget swin-widget-about">
                        <div class="clerfix">
                          <div className="header-logo">
                            <img
                              src="/assets/images/logo/logo-ibis.png"
                              alt="IBIS"
                              className="logo-img footer-r site_logo footer_logo"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-9 footer-tab ">
                    <div className="row ">
                      <div className="col-md-12  d-md-flex">
                      <div className="col-md-6 col-sm-6 mb-3" style={{ paddingRight: "15px" }}>
                          <div className="ft-area1 ">
                            <div className="swin-widget widget-about">
                              <div className="title-widget footer_heading">
                                Lobby Reception{" "}
                              </div>
                              <div class="about-contact-info clearfix">
                                <div class="info-content phone-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-phone"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>+91 2069137820  </p>
                                  </div>
                                </div>
                                <div class="info-content email-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-envelope"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>lobbyreception.pune@jpmchase.com</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-6 mb-3" style={{ paddingRight: "15px" }}>
                          <div className="ft-area1">
                            <div className="swin-widget widget-about">
                              <div className="title-widget footer_heading">
                              Conference Center{" "}
                              </div>
                              <div class="about-contact-info clearfix">
                                <div class="info-content phone-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-phone"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>+91 9175707137 </p>
                                  </div>
                                </div>
                                <div class="info-content email-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-envelope"></i>
                                  </div>
                                  <div class="info-text ">
                                    <p>conferencecentre.pune@jpmchase.com</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className="border-white" />

                    <div className="row">
                      <div className="col-md-12  d-md-flex">
                        <div class="col-md-6 col-sm-6">
                          <div className="ft-area1">
                            <div className="swin-widget widget-about">
                              <div className="title-widget footer_heading">
                                Employee Dining
                              </div>
                              <div class="about-contact-info clearfix">
                                <div class="info-content phone-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-phone"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>+91 9175701219</p>
                                  </div>
                                </div>
                                <div class="info-content email-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-envelope"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>
                                     the.pune.exchange@jpmchase.com</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6 col-sm-6">
                          <div className="ft-area1">
                            <div className="swin-widget widget-about">
                              <div className="title-widget footer_heading">
                                Pantry Services
                              </div>
                              <div class="about-contact-info clearfix">
                                <div class="info-content phone-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-phone"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>+91 9175701240</p>
                                  </div>
                                </div>
                                <div class="info-content email-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-envelope"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>
                                    the.pune.exchange@jpmchase.com</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
